import React, { Fragment } from 'react';
import { ArrowRightIcon, CheckCircle2Icon, Volume2Icon, PenToolIcon, TypeIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function UniqueMechanism() {
  const steps = [{
    icon: <Volume2Icon className="w-8 h-8 text-white" data-id="element-419" />,
    title: 'SONIDO',
    desc: 'Primero el niño reconoce el sonido.',
    bgColor: 'bg-kid-purple'
  }, {
    icon: <PenToolIcon className="w-8 h-8 text-white" data-id="element-420" />,
    title: 'TRAZO',
    desc: 'Después conecta ese sonido con el trazo de la letra.',
    bgColor: 'bg-kid-orange'
  }, {
    icon: <TypeIcon className="w-8 h-8 text-white" data-id="element-421" />,
    title: 'PALABRA',
    desc: 'Y recién entonces puede construir palabras con sentido.',
    bgColor: 'bg-kid-lime'
  }];
  const benefits = [{
    text: 'aumenta la comprensión',
    color: 'text-kid-purple',
    borderColor: 'border-l-kid-purple'
  }, {
    text: 'disminuye la frustración',
    color: 'text-kid-pink',
    borderColor: 'border-l-kid-pink'
  }, {
    text: 'el niño gana seguridad',
    color: 'text-kid-sky',
    borderColor: 'border-l-kid-sky'
  }, {
    text: 'la práctica se vuelve natural',
    color: 'text-kid-lime',
    borderColor: 'border-l-kid-lime'
  }];
  return <section className="py-8 md:py-20 px-4 bg-gradient-to-br from-kid-sky/5 via-white to-kid-purple/5 relative overflow-hidden" data-id="element-422">
      <div className="max-w-5xl mx-auto relative z-10" data-id="element-423">
        <FadeIn data-id="element-424">
          <div className="text-center mb-6 md:mb-10" data-id="element-425">
            <p className="text-xl md:text-2xl text-gray-800 font-bold max-w-2xl mx-auto" data-id="element-426">
              El cerebro infantil aprende así:
            </p>
          </div>
        </FadeIn>

        {/* The Visual Diagram */}
        <div className="mb-8 md:mb-16" data-id="element-427">
          <div className="flex flex-col md:flex-row items-stretch justify-center gap-4 md:gap-6 relative" data-id="element-428">
            {steps.map((step, idx) => <Fragment key={idx} data-id="element-429">
                <FadeIn delay={idx * 0.1} className="relative z-10 w-full md:w-1/3 flex" data-id="element-430">
                  <div className={`flex flex-col items-center text-center p-6 md:p-10 rounded-2xl ${step.bgColor} shadow-sm w-full`} data-id="element-431">
                    <div className="w-14 h-14 md:w-16 md:h-16 rounded-xl bg-white/20 flex items-center justify-center mb-4 md:mb-6" data-id="element-432">
                      {step.icon}
                    </div>
                    <h3 className="text-lg md:text-xl font-bold mb-2 md:mb-3 tracking-tight text-white" data-id="element-433">
                      {step.title}
                    </h3>
                    <p className="text-sm md:text-base font-medium text-white/90 leading-relaxed" data-id="element-434">
                      {step.desc}
                    </p>
                  </div>
                </FadeIn>

                {/* Arrow for mobile */}
                {idx < steps.length - 1 && <div className="md:hidden py-1 flex justify-center" data-id="element-435">
                    <div className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center border border-gray-200" data-id="element-436">
                      <ArrowRightIcon className="w-4 h-4 text-gray-400 rotate-90" data-id="element-437" />
                    </div>
                  </div>}

                {/* Arrow for desktop */}
                {idx < steps.length - 1 && <div className="hidden md:flex absolute top-1/2 -translate-y-1/2 z-20" style={{
              left: `${(idx + 1) * 33.33}%`,
              transform: 'translate(-50%, -50%)'
            }} data-id="element-438">
                    <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center border-2 border-gray-100 shadow-md" data-id="element-439">
                      <ArrowRightIcon className="w-6 h-6 text-gray-400" data-id="element-440" />
                    </div>
                  </div>}
              </Fragment>)}
          </div>
        </div>

        <div className="max-w-4xl mx-auto bg-gradient-to-br from-white to-kid-purple/5 rounded-2xl p-6 md:p-12 border border-kid-purple/20 relative overflow-hidden" data-id="element-441">
          <FadeIn data-id="element-442">
            <div className="text-center mb-6 md:mb-10 relative z-10" data-id="element-443">
              <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-3 md:mb-4 leading-tight" data-id="element-444">
                <span className="block mb-1 text-gray-500 font-medium text-sm md:text-base" data-id="element-445">
                  Ese es el principio del
                </span>
                <span className="text-kid-purple block text-xl md:text-2xl" data-id="element-446">
                  Sistema de Lectura en Orden Correcto™
                </span>
              </h3>
              <p className="text-sm md:text-base text-gray-600 font-medium" data-id="element-447">
                Cuando se respeta ese orden:
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4 relative z-10" data-id="element-448">
              {benefits.map((benefit, idx) => <div key={idx} className={`flex items-center gap-3 bg-white p-3 md:p-4 rounded-xl border border-gray-200 border-l-[4px] ${benefit.borderColor} shadow-sm`} data-id="element-449">
                  <CheckCircle2Icon className={`w-5 h-5 ${benefit.color} flex-shrink-0`} data-id="element-450" />
                  <span className="text-sm md:text-base font-medium text-gray-700" data-id="element-451">
                    {benefit.text}
                  </span>
                </div>)}
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}